import axios from "axios";
import { OldProtocolService } from "./service";
import { keycloak } from "../../../../lib/keycloak";
import { format } from 'date-fns';
import { ProtocolloPre2015DataResponse, ProtocolloPre2015Filters, ProtocolloPre2015Response } from "./dto";

export class OldProtocolServiceImpl implements OldProtocolService {


    public GetAllOldProtocols(filters: ProtocolloPre2015Filters): Promise<ProtocolloPre2015Response> {
        return axios.get("/api/old-entry-protocol", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                sort: filters.sort,
                order: filters.order,
                page: filters.page ? filters.page : 0,
                customerId: filters.customer
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetOldProtocolById(id: string): Promise<ProtocolloPre2015DataResponse> {
        return axios.get("/api/old-entry-protocol/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

}